<div class="info-tooltip" [placement]="placement" ngbTooltip="{{ text }}" tooltipClass="green-tooltip">
  <svg-icon [src]="iconPath ? iconPath : '/assets/shared/svg/info.svg'"></svg-icon>
</div>